import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import * as moment from 'moment';
import { CeqTableComponent } from '../../../common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { PrintChildRendered } from '../../../common/renders/print-child-rendered';
import { ViewChildRendered } from '../../../common/renders/view-child-rendered';

import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { AdjustService } from '../adjust.service';
import { AdjustCeveCutComponent } from '../adjust-ceve-cut/adjust-ceve-cut.component';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { CeqAdjust } from 'src/app/ceq/common/models/AdjustUnit.Model';
import { Unit } from 'src/app/ceq/common/models/Unit.Model';
import { MessagingService } from 'src/app/services/messaging/messaging.service';
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';
import { CalendarService } from 'src/app/ceq/configuration/calendar/calendar.service';
import { Calendar } from 'src/app/ceq/common/models/Calendar.Model';
import { Icon } from 'ol/style';


@Component({
  selector: 'app-adjust-ceve',
  templateUrl: './adjust-ceve.component.html',
  styleUrls: ['./adjust-ceve.component.scss'],
})
export class AdjustCeveComponent implements OnInit, OnDestroy {

  constructor(
    private globalFunctionService: GlobalFunctionsService,
    private settings: SettingsService,
    private adjustServive: AdjustService,
    private notificationService: MessagingService,
    private calendarService: CalendarService
  ) {

  }

  @ViewChild(AdjustCeveCutComponent) ceveCutAdj: AdjustCeveCutComponent;
  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;

  options: GridOptions;
  user: UserLogin;
  selectedNode: Unit;
  selectedNodeName: string;
  adjusRunning: boolean = false;
  loading: Boolean = false;
  activeAdjust: CeqAdjust;
  hasStatusActivity: boolean = false;
  hasViewActivity: boolean = false;
  validateTransit: boolean = false;
  useV2: boolean = false;
  adjProgressTimer: any;

  showHistory: boolean = false;
  adjustHistory: CeqAdjust[] = [];
  showHistoryButtons: boolean = false;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childPrintRenderer: PrintChildRendered,
      childViewRenderer: ViewChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  }

  columnDefs = [
    {
      headerName: 'Region Origen',
      field: 'RegionOrigin',
      width: 15,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Clasificación Origen',
      field: 'TypeOrigin',
      width: 10,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Nodo Origen',
      field: 'OutputName',
      width: 35,
      cellClass: 'align-start',
      editable: false,
      resizable: true,
      unSortIcon: true,
      sortable: true
    },
    {
      headerName: 'Region Destino',
      field: 'RegionDestiny',
      width: 15,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Clasificación Destino',
      field: 'TypeDestiny',
      width: 10,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Nodo Destino',
      field: 'InputName',
      width: 35,
      cellClass: 'align-start',
      editable: false,
      resizable: true,
      unSortIcon: true,
      sortable: true
    },
    {
      headerName: 'Transporte',
      field: 'Tractor',
      width: 10,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Remisión',
      field: 'Remission',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      resizable: true,
      unSortIcon: true,
      sortable: true
    },
    {
      headerName: 'Equipo',
      field: 'ContainerCode',
      width: 10,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'PT',
      field: 'PT',
      width: 10,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'EV',
      field: 'EV',
      width: 10,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Total',
      field: 'Total',
      width: 10,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Estatus',
      field: 'Status',
      width: 5,
      cellClass: 'align-start',
      editable: false,
      resizable: true
    },
    {
      headerName: 'Fecha Cierre',
      field: 'CloseDate',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      resizable: true,
      unSortIcon: true,
      sortable: true,
      cellRenderer: (params: any) => moment(params.data.CloseDate).format('YYYY-MM-DD HH:mm')
    },
    {
      headerName: 'Fecha Venta',
      field: 'SellDate',
      width: 15,
      cellClass: 'align-start',
      editable: false,
      resizable: true,
      unSortIcon: true,
      sortable: true,
      cellRenderer: (params: any) => moment(params.data.SellDate).format('YYYY-MM-DD')
    }
  ];

  gridEmiter(gridOptions: GridOptions) {
    this.options = gridOptions;
    if (this.ceqGrid != null && this.ceqGrid != undefined) {
      this.ceqGrid.data = [];
    }
  }

  async ngOnInit() {
    this.user = this.settings.getUser();
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();

    await this.settings.getSettingsByKey('ADJVALCVT')
      .toPromise()
      .then(resp => {
        this.validateTransit = resp.Value === '1';
        console.log(resp);
      })
      .catch(err => {
        console.error(err);
      });

    await this.validateInventoryCut();
  }

  ngOnDestroy(): void {
    clearInterval(this.adjProgressTimer);
    this.adjProgressTimer = null;
  }

  validateInventoryCut() {
    this.calendarService
      .CalendarInventoryLock()
      .subscribe((calendar: Calendar[]) => {
        if (calendar.length == 1) {
          this.hasStatusActivity = false;
          this.hasViewActivity = false;
        } else {
          let activities = this.settings.getUserAccess();
          this.hasStatusActivity = activities.includes('ADJPREVAL');
          this.hasViewActivity = activities.includes('ADJVIEWWEB');
        }
      });
  }

  changeNode(event: any) {
    if (event === null || event === undefined) { return; }

    this.selectedNode = event;
    this.getUnitAdjustVersion();
    if (!this.showHistory) {
      this.refreshGrid();
    }
    else {
      this.getAdjustHistory();
    }

  }

  clearNode() {
    this.selectedNode = undefined;
    if (this.ceqGrid != null && this.ceqGrid != undefined) {
      this.ceqGrid.data = [];
    }
    return;
  }


  async refreshGrid() {
    if (this.selectedNode.UnitId == undefined || this.selectedNode.UnitId == null || this.selectedNode.UnitId == 0) {
      return;
    }
    this.ceqGrid?.gridOptions?.api.showLoadingOverlay();

    if (this.selectedNode == undefined) {
      if (this.ceqGrid != null && this.ceqGrid != undefined) {
        this.ceqGrid.data = [];
      }
      this.globalFunctionService.messageBimbo('Debe seleccionar el nodo el cual se va a compulsar', 'warning', '');
      return;
    }

    await this.adjustServive.ongoingReport(this.selectedNode.UnitId).toPromise()
      .then(data => {
        if (this.ceqGrid != null && this.ceqGrid != undefined) {
          this.ceqGrid.data = data;
        }
      })
      .catch(err => {
        console.log(err);
        this.showErrorMessage(err);
      });

    this.ceqGrid?.gridOptions?.api.hideOverlay();

    //debug
    // this.ValidateAdjustState();
  }

  /**Obtiene la version de la compulsa */
  async getUnitAdjustVersion() {
    await this.adjustServive.getAdjustVersion(this.selectedNode.UnitId)
      .toPromise()
      .then(data => {
        console.log(data);
        if (data?.Success) {
          this.useV2 = data.Message;
          this.showHistoryButtons = true;
        }
      })
      .catch(err => {
        console.error(err);
      })
  }

  /**Evento que se invoca al validar pre requisitos */
  async ValidateAdjustState() {
    if (this.selectedNode.UnitId == undefined || this.selectedNode.UnitId == null || this.selectedNode.UnitId == 0) {
      return;
    }

    this.loading = true;
    if (this.validateTransit) {
      if (this.ceqGrid != null && this.ceqGrid != undefined) {
        if (this.ceqGrid.data.length > 0) {
          this.globalFunctionService.messageBimbo('Existen remisiones en transito, favor de validarlas con el equipo certificador de la compulsa', 'warning', '');
          this.loading = false;
          return;
        }
      }
    }

    if (this.useV2) {
      await this.ValidateAdjustStateV2();
    }
    else {
      await this.adjustServive.validateAdjustState(this.selectedNode.UnitId).toPromise()
        .then(resp => {
          if (resp.AdjustCode === '') {
            this.startAdjust();
          }
          else {
            this.loading = false;
            this.activeAdjust = resp;
            this.adjusRunning = true;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.adjusRunning = false;
          this.showErrorMessage(err);
        });
    }
  }

  /**Evento que se invoca al visualizar compulsa */
  async ViewCurrentAdjust() {
    if (this.selectedNode.UnitId == undefined || this.selectedNode.UnitId == null || this.selectedNode.UnitId == 0) {
      return;
    }

    try {
      this.loading = true;
      await this.adjustServive.validateAdjustActive(this.selectedNode.UnitId)
        .toPromise()
        .then(resp => {
          this.loading = false;
          if (resp.AdjustCode == '') {
            this.globalFunctionService.messageBimbo('El nodo seleccionado no tiene una compulsa activa', 'info', '');
          }
          else {
            this.activeAdjust = resp;
            this.adjusRunning = true;
          }
        })
        .catch(err => {
          this.loading = false;
          this.showErrorMessage(err);
        });
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

  }

  async startAdjust() {
    this.loading = true;
    await this.adjustServive.startAdjust(this.selectedNode.UnitId).toPromise()
      .then(data => {
        this.showHistoryButtons = false;
        this.loading = false;
        this.activeAdjust = data;
        this.adjusRunning = true;
        //muestro barra de conteo solo en el nodo incial
        if (this.selectedNode.UnitId == this.user.UnitId) {
          this.localStartAdjustNotification();
        }
      })
      .catch(err => {
        this.loading = false;
        console.log(err);
        this.showErrorMessage(err);
      });

  }

  async cancelAdjust() {
    this.adjusRunning = false;
    this.showHistoryButtons = true;
    //oculto barra de conteo solo en el nodo incial
    if (this.selectedNode.UnitId == this.user.UnitId) {
      this.localEndAdjustNotification();
    }
    await this.refreshGrid();
  }


  showErrorMessage(err) {
    if (err?.error?.Message !== '' && err?.error?.Message !== undefined) {
      this.globalFunctionService.messageBimbo(err.error.Message, 'warning', '');
    }
    else if (err?.message !== '' && err?.message !== undefined) {
      this.globalFunctionService.messageBimbo(err.message, 'warning', '');
    }
    else {
      this.globalFunctionService.messageBimbo(err, 'warning', '');
    }
  }



  async ValidateAdjustStateV2() {
    await this.adjustServive.startAdjustV2(this.selectedNode.UnitId).toPromise()
      .then(resp => {
        this.loading = false;
        this.activeAdjust = resp;
        this.adjusRunning = true;
        this.showHistoryButtons = false;
        //muestro barra de conteo solo en el nodo incial
        if (this.selectedNode.UnitId == this.user.UnitId) {
          this.localStartAdjustNotification();
        }
      })
      .catch(err => {
        this.loading = false;
        console.log(err);
        this.adjusRunning = false;
        this.showErrorMessage(err);
      });
  }

  localStartAdjustNotification() {
    this.notificationService.currentMessage$.next({
      data: {
        Action: "AdjustStarted",
        CreatedAt: this.activeAdjust.CreatedAt,
        CountDown: this.activeAdjust.AdjustCountdown,
      },
      notification: {
        title: 'Compulsa iniciada',
        body: 'Compulsa EV',
        icon: ''
      }
    })
  }

  localEndAdjustNotification() {
    this.notificationService.currentMessage$.next({
      data: {
        Action: "AdjustEnded"
      },
      notification: {
        title: 'Compulsa Finalizada',
        body: 'Compulsa EV',
        icon: ''
      }
    })
  }

  async showAdjustHistory() {
    this.showHistory = true;
    this.adjusRunning = false;

    await this.getAdjustHistory();
  }

  hideAdjustHistory() {
    this.showHistory = false;
    this.adjusRunning = false;
  }

  async getAdjustHistory() {
    if (this.selectedNode == null || this.selectedNode == undefined) { return; }

    this.loading = true;
    await this.adjustServive.getAdjustHistory(this.selectedNode.UnitId)
      .toPromise()
      .then(data => {
        this.adjustHistory = data;
      })
      .catch(err => {
        console.error(err);
        this.globalFunctionService.messageToast('Error al obtener el historial de la compulsa', 'error');
      });

    this.loading = false;
  }

  async showAdjustHistoryDetail(adjust: CeqAdjust) {
    // this.showHistory = false;
    this.activeAdjust = adjust
    this.adjusRunning = true;
  }

}
